import React from "react";
import { Heading } from "@dip/helsecore/src/components/shared/Heading/Heading";
import type { Image } from "@dip/helsecore/src/types/Image";
import Base, { type StatisticsCardBaseProps } from "../Base/Base";

export type KeyFigureConfig = {
  indicator?: string;
  indicatorDescription?: string;
  trendIcon?: Image;
  trendText?: string;
};

interface KeyFigureProps extends Omit<StatisticsCardBaseProps, "children"> {
  config: KeyFigureConfig;
  layoutHasTitle: boolean;
}

export default function KeyFigure(props: Readonly<KeyFigureProps>) {
  const {
    config: {
      indicator,
      indicatorDescription,
      trendIcon,
      trendText
    },
    layoutHasTitle,
    ...baseProps
  } = props;

  return (
    <Base {...baseProps}>
      <Heading className="flex flex-col gap-xxs mt-sm" headingLevel={layoutHasTitle ? "h4" : "h3"}>
        { indicator && <span className="text-xxl text-action font-bold">{indicator}</span> }
        { indicatorDescription && <span className="text-lg font-semibold">{indicatorDescription}</span> }
        { (trendIcon || trendText)
          && (
            <div className="flex flex-row items-center gap-xxs mt-sm">
              { trendIcon && <img className="h-3 w-3" src={trendIcon.url} alt={trendIcon.alt} /> }
              { trendText && <span className="font-normal text-xs">{trendText}</span> }
            </div>
          )}
      </Heading>
    </Base>
  );
}
